import { useState } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import BottomNav from './components/common/BottomNav.jsx';
import SplashScreen from './components/common/SplashScreen.jsx';
import HomePage from './pages/Home/HomePage.jsx';
import EmergencyPage from './pages/Emergency/EmergencyPage.jsx';
import SettingsPage from './pages/Settings/SettingsPage.jsx';
import { AdBanner } from './components/common/AdBanner.jsx';
import AppDownloadBanner from './components/common/AppDownloadBanner.jsx';

/**
 * 페이지를 언마운트하지 않고 CSS display로 숨김/표시 전환 (방법 A)
 * - 지도 상태, 카카오맵 인스턴스, 5분 자동 갱신 타이머가 모두 유지됨
 * - /location, /settings 이동 후 복귀 시 API 재호출 없음
 */
function AppContent() {
  const location = useLocation();
  const path = location.pathname;

  const show = (targetPath) => ({
    display: path === targetPath ? 'contents' : 'none',
  });

  return (
    <>
      <AppDownloadBanner />
      <div className="app-layout">
      <main className="app-main">
        <div style={show('/')}>
          <HomePage />
        </div>
        <div style={show('/emergency')}>
          <EmergencyPage />
        </div>
        <div style={show('/settings')}>
          <SettingsPage />
        </div>
      </main>
      <AdBanner />
      <BottomNav />
    </div>
    </>
  );
}

export default function App() {
  const [showSplash, setShowSplash] = useState(true);

  return (
    <BrowserRouter>
      {showSplash && <SplashScreen onComplete={() => setShowSplash(false)} />}
      <AppContent />
    </BrowserRouter>
  );
}
